import { render, staticRenderFns } from "./JiGuiLixian.vue?vue&type=template&id=3911adeb&scoped=true&"
import script from "./JiGuiLixian.vue?vue&type=script&lang=js&"
export * from "./JiGuiLixian.vue?vue&type=script&lang=js&"
import style0 from "./JiGuiLixian.vue?vue&type=style&index=0&id=3911adeb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3911adeb",
  null
  
)

export default component.exports